import comp from "./StudentActivityDetails";

export default comp;
